module.exports = __webpack_public_path__ + "img/LOGO_DARK_MODE.1e4a3ef6.png";